module.exports = __webpack_public_path__ + "img/lawpay-pay-invoice-btn-350x130.71a26825.png";